document.addEventListener('DOMContentLoaded', function() {
  const checkoutForm = document.getElementById('cart');
  const policyCheckbox = document.getElementById('policy-check');
  const checkoutButton = document.getElementById('checkout');

  if (checkoutForm && policyCheckbox && checkoutButton) {
    checkoutForm.addEventListener('submit', function(e) {
      if (!policyCheckbox.checked) {
        e.preventDefault();
        const errorDiv = document.getElementById('cart-errors');
        if (errorDiv) {
          errorDiv.textContent = 'Please read and accept the privacy policy before proceeding to checkout.';
          errorDiv.style.color = '#dc2626';
          errorDiv.style.marginTop = '1rem';
          errorDiv.style.textAlign = 'center';
        }
        policyCheckbox.focus();
      }
    });

    // Clear error when checkbox is checked
    policyCheckbox.addEventListener('change', function() {
      const errorDiv = document.getElementById('cart-errors');
      if (errorDiv) {
        errorDiv.textContent = '';
      }
    });
  }
});
